



























import { defineComponent } from '@nuxtjs/composition-api';
import { BaseBanner, BaseButton } from '@bambeehr/pollen';
import migrationBanner from './content';

// Announces the move to the new Bambee platform and sends the owner to schedule a migration call
// (BIO-1908). Presentational only — who sees it, and whether it has been dismissed, is decided by
// the caller so this component stays trivial to render in isolation and in tests.
// Emits `dismiss` when the close control is used; persisting that is the caller's job.
export default defineComponent({
  name: 'MigrationBanner',

  components: {
    BaseBanner,
    BaseButton,
  },

  emits: ['dismiss', 'cta-click'],

  setup() {
    return {
      content: migrationBanner,
    };
  },
});
